module.exports = __webpack_public_path__ + "img/guess.02425015.jpg";